<div class="content" [ngClass]="firmante.seleccionado ? 'seleccionado' : ''" [class.campos-editables-firmante--inline]="inlineMode">
  <div class="flex" *ngIf="!inlineMode" (click)="mostrarEstado(firmante)">
    <h6>{{firmante.tipoFirmante.desc}}</h6>
    <svg class="icon-arrow" [ngClass]="firmante.seleccionado ? 'icon-arrow-down':''">
      <use xlink:href="#icon-arrow"></use>
    </svg>
  </div>
  <div *ngIf="inlineMode || firmante.seleccionado">
  <app-campos-editables-add-campos [firmante]="firmante"></app-campos-editables-add-campos>
  </div>
</div>
